import { render, staticRenderFns } from "./UserProviderByContact.vue?vue&type=template&id=2ffdf6c6&scoped=true"
import script from "./UserProviderByContact.vue?vue&type=script&lang=js"
export * from "./UserProviderByContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffdf6c6",
  null
  
)

export default component.exports